<template>
  <div class="city-select-box show-flex-box-c">
    <ul class="city-nav show-flex-box-r">
      <li v-for="(item,index) in navList" :key="index" class="show-flex-box-r">
        <span :class="{'selected': selectedIndex == index}">{{item}}</span>
      </li>
    </ul>
    <div class="city-box show-flex-box-c">
      <!-- <span>请选择</span> -->
      <strong class="show-flex-box-c">
        <span
          v-for="(item,index) in showList"
          :key="index"
          @click="selectedProvince(item,index)"
        >{{item.name}}</span>
      </strong>
    </div>
  </div>
</template>

<script>
import { province } from "@/../static/js/pcas.js";

export default {
  name: "city_select_cpn",
  props: {},
  data() {
    return {
      navList: ["省", "市", "区", "街道"],
      selectedIndex: 0,
      showList: [],
      provinceSelected: "",
      citySelected: "",
      areaed: "",
      streeted: "",
      location: {},
      numObj: {},
      initStatus: true
    };
  },
  created() {
    this.showList = [...province];
  },
  methods: {
    selectedProvince: function(item, index) {
      if (this.selectedIndex == 0) {
        this.showList = this.showList[index].children;
        this.selectedIndex = 1;
        this.provinceSelected = item.name;
        this.location.province = this.provinceSelected;
        this.numObj.provinceCode = item.code + "0000";
      } else if (this.selectedIndex == 1) {
        this.showList = this.showList[index].children;
        this.selectedIndex = 2;
        this.citySelected = item.name;
        this.location.city = this.citySelected;
        this.numObj.cityCode = item.code + "00";
      } else if (this.selectedIndex == 2) {
        this.showList = this.showList[index].children;
        this.selectedIndex = 3;
        this.areaed = item.name;
        this.location.area = this.areaed;
        this.numObj.areaCode = item.code;
      } else if (this.selectedIndex == 3) {
        this.showList = this.showList[index].children;
        this.selectedIndex = 4;
        this.streeted = item.name;
        this.location.street = this.streeted;
        this.numObj.streetCode = item.code;
      }
      if (this.showList == null) {
        // console.log(this.numObj);
        this.$emit("area_select", this.location, this.numObj);
        this.showList = [...province];
        this.selectedIndex = 0;
      }
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.city-select-box {
  height: 252px;
  width: 448px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  margin-top: 5px;
  & > .city-nav {
    width: 100%;
    height: 29px;
    border-bottom: 1px solid #e5e5e5;
    border-top: 1px solid #fff;
    & > li {
      width: 25%;
      justify-content: center;
      align-items: center;
      & > span {
        height: 14px;
        font-size: 14px;
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: #808080;
      }
      & > span.selected {
        height: 14px;
        font-size: 14px;
        font-family: PingFang-SC-Bold;
        font-weight: bold;
        color: #191d21;
      }
    }
  }
  & > .city-box::-webkit-scrollbar {
    width: 3px;
    background: #fff;
    border-radius: 2px;
  }
  & > .city-box::-webkit-scrollbar-thumb {
    width: 3px;
    height: 96px;
    background: #e5e5e5;
    border-radius: 2px;
  }
  & > .city-box {
    overflow-y: scroll;
    width: 100%;
    height: 222px;
    & > strong {
      padding-top: 6px;
      & > span {
        cursor: pointer;
        display: block;
        line-height: 42px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #191d21;
        padding-left: 40px;
      }
      & > span:hover {
        background: #f8f8f8;
        color: #555;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mars_box_store/common/area_select_cpn.vue